<mat-form-field appearance="outline" [formGroup]="formulario" [ngClass]="classe">
  <mat-label>{{descricao}}</mat-label>
  <mat-select [disabled]="desabilitado" [formControlName]="nomeControle" (selectionChange)="onSelectionChange($event)">
    <mat-option *ngFor="let opcao of opcoes" [value]="opcao?.codigo">{{opcao.label}}</mat-option>
  </mat-select>
  <mat-hint>{{textoAjuda}}</mat-hint>
</mat-form-field>